import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import * as CONSTANTS from "../CONSTANTS";
import axios from 'axios';
import { register, reset } from '../reduxAuth/authSlice';

function CheckOut() {

    const [processing, setProcessing]                                                   = useState(false);
    const {user, isLoading, isError, isSuccess, message}                                = useSelector((state) => state.auth);

    const [pickUpLocation, setPickUpLocation]                                           = useState("");
    const [pickUpDate, setPickUpDate]                                                   = useState("");
    const [pickUpTime, setPickUpTime]                                                   = useState("");
    const dispatch                                                                      = useDispatch();

    const [activeTab, setActiveTab]                                                     = useState('login'); // 'login' is the default tab
    const [countryListing, setCountryListing]                                           = useState([]);
    
    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    const cartItems                                                                     = useSelector((state) => state.cart.items);

    //Registration Checkout
    const firstNameRegRef                                                               = useRef();
    const lastNameRegRef                                                                = useRef();
    const emailRegRef                                                                   = useRef();
    const passwordRegRef                                                                = useRef();
    const phoneNumberRegRef                                                             = useRef();
    const countryRegRef                                                                 = useRef();

    useEffect(() => {
        pickUpCollection();
        collectionOfCountries();
    },[])

    useEffect(() => {

        console.log("USEEFFECT");

        console.log(Date.now());
        console.log(user);
        console.log("++++++++++++++++++++++");

        if(isError){
            toast.error(message)
        }
         

        //  dispatch(reset())
    },[user, isError, isSuccess, message, dispatch])

    
    // Calculate the total cost
    const totalCost = cartItems.reduce((total, item) => {
      return total + item.product.price * item.quantity;
    }, 0);

    const pickUpCollection = async () => {
        // Retrieve pickup details from localStorage
        const storedPickupDetails = JSON.parse(localStorage.getItem(CONSTANTS.PICKUP_DETAILS));
        
        if (storedPickupDetails) {
            setPickUpLocation(storedPickupDetails.location || "");
            setPickUpDate(storedPickupDetails.date || "");
            setPickUpTime(storedPickupDetails.time || "");
        }
    }

    const handleSubmitPayment = async () => {
        try{

           
        }catch(err){
            console.log(err);
        }
    }

    const collectionOfCountries = async () => {
        try{

            const countryList = await axios.get(CONSTANTS.API_URL + "settings/country/list/v1");
            setCountryListing(countryList.data);
        }catch(err){
            console.log(err);
        }
    }

    const handleCheckoutLogin = async (e) => {
        e.preventDefault();
        try{


        }catch(err){
            console.log(err);
        }
    }
    
    const handleCheckoutRegistration = async (e) => {
        e.preventDefault();
        try{
          //  setProcessing(true);
            const countryString = countryRegRef.current.value;
            const codeNcountry  =  countryString.split("-");

            const regObject = {
                "firstName" : firstNameRegRef.current.value,
                "lastName" : lastNameRegRef.current.value,
                "email" : emailRegRef.current.value,
                "password" : passwordRegRef.current.value,
                "phonenumber" : phoneNumberRegRef.current.value,
                "country" : codeNcountry[0],
                "countryCode" : codeNcountry[1]
            }

            console.log("--------<<<<<<>>>>>>>--------");
            console.log(regObject);
            //const regItem = await axios.post(CONSTANTS.API_URL + "auth/register", regObject);
            //console.log(regItem);
            dispatch(register(regObject));
            //setProcessing(false);

        }catch(err){
            console.log(err);
           // setProcessing(false);
        }

    }

  return (
    <div className="standard-ountline">
        <div className="standard-area"> CheckOut
            <div className="container">
                <div className="checkout-container">
                    <div className="fl-cover70">    
                        <div className="person-listing">
                            <div className="inner-checkhout-listing">
                                {
                                    user ?
                                    <form onSubmit={handleSubmitPayment}>
                                        <div className="form-group">
                                            <div className="tit-label">Email</div> 
                                            <input type="email" className="form-control" value={user.email} required/>
                                        </div>
                                        <hr/>
                                        <div className="flexme checkout-fl-row">
                                            <div className="fl-cover50">
                                                <div className="form-group">
                                                    <div className="tit-label">First Name</div> 
                                                    <input type="text" className="form-control" value={user.name} required/>
                                                </div>
                                            </div>
                                            <div className="fl-cover50">
                                                <div className="form-group">
                                                    <div className="tit-label">Last Name</div> 
                                                    <input type="text" className="form-control" value={user.surname} required/>
                                                </div>
                                            </div>                                   
                                        </div>
                                        <div className="flexme checkout-fl-row">
                                            <div className="fl-cover50">
                                                <div className="form-group">
                                                    <div className="tit-label">Phone</div> 
                                                    <input type="text" className="form-control" value={user.phonenumber} required/>
                                                </div>
                                            </div>
                                            <div className="fl-cover50">
                                                <div className="form-group">
                                                    <div className="tit-label">Country</div> 
                                                    <input type="text" className="form-control" value={user.country} required/>
                                                </div>
                                            </div>                                   
                                        </div>
                                    </form>    
                                : 
                                <div className="auth-container">
                                        {/* Tab Headers */}
                                        <div className="tab-header">
                                            <button
                                                onClick={() => handleTabClick('login')}
                                                className={activeTab === 'login' ? 'active' : ''}
                                            >
                                                Login
                                            </button>
                                            <button
                                                onClick={() => handleTabClick('register')}
                                                className={activeTab === 'register' ? 'active' : ''}
                                            >
                                                Register
                                            </button>
                                        </div>
                            
                                        {/* Forms */}
                                        <div className="form-container">
                                            {/* Login Form */}
                                            <div
                                                className={`form login-form ${activeTab === 'login' ? 'slide-in' : 'slide-out'}`}
                                            >
                                                <h2>Login</h2>
                                                <form onSubmit={handleCheckoutLogin}>
                                                    {/* Form fields for login */}
                                                    <div className="form-group mgbot10">
                                                        <input type="text" className="form-control" placeholder="Email Address" required />
                                                    </div>
                                                    <div className="form-group mgbot10">
                                                         <input type="password" className="form-control"  placeholder="Password" required />
                                                    </div>
                                                    
                                                    <button type="submit" className="btn btn-activator">Login</button>
                                                </form>
                                            </div>
                            
                                            {/* Register Form */}
                                            <div
                                                    className={`form register-form ${activeTab === 'register' ? 'slide-in' : 'slide-out'}`}
                                                >
                                                <h2>Register</h2>
                                                <form onSubmit={handleCheckoutRegistration}>
                                                    {/* Form fields for registration */}
                                                    <div className="form-group mgbot10">
                                                         <div className="lbl-small text-label-frm">First Name</div>
                                                        <input type="text" className="form-control" placeholder="First Name" ref={firstNameRegRef} required />
                                                    </div>
                                                    <div className="form-group mgbot10 text-label-frm">
                                                        <div className="lbl-small">Last Name</div>
                                                        <input type="text" className="form-control" placeholder="Last Name" ref={lastNameRegRef} required />
                                                    </div>
                                                    <div className="form-group mgbot10 text-label-frm">
                                                        <div className="lbl-small">Email</div>
                                                        <input type="text" className="form-control" placeholder="Email Address" ref={emailRegRef} required />
                                                    </div>
                                                    <div className="form-group mgbot10 text-label-frm">
                                                         <div className="lbl-small">Password</div>
                                                         <input type="password" className="form-control"  placeholder="Password" ref={passwordRegRef} required />
                                                    </div>
                                                    <div className="form-group mgbot10 text-label-frm">
                                                        <div className="lbl-small">Cell Phone</div>
                                                        <input type="text" className="form-control" placeholder="Phone Number" ref={phoneNumberRegRef} required />
                                                    </div>
                                                    
                                                    {
                                                        countryListing.length > 0 && (
                                                            <div className="form-group mgbot10 text-label-frm">
                                                                <div className="lbl-small">Country</div>
                                                                <select className="form-control" ref={countryRegRef}>
                                                                    {
                                                                        countryListing.map((country, index) => {
                                                                            return <option value={country.name + "-" + country.code} key={index}>
                                                                                ({country.code} ) {country.name} 
                                                                            </option>
                                                                        })
                                                                    }
                                                                </select>
                                                                
                                                            </div>
                                                        )
                                                    }
                                                       
                                                    <button type="submit" className="btn btn-activator">Register</button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>   
                        </div>                 
                    </div>
                    <div className="fl-cover30">  
                        <div className="check-out-box">
                           <h3 className="check-title">Checkout</h3>
                            <div className="item-info-checkout">
                                <h4 className="sub-check">PICK UP</h4>
                                <div className="show-pickup">
                                        <div className="flexspace-between">
                                            <div className="tit-label">Pick up Location</div>
                                            <div className="selected-label">{pickUpLocation}</div>
                                        </div>
                                        <div className="flexspace-between">
                                            <div className="tit-label">Pick up Date</div>
                                            <div className="selected-label">{pickUpDate}</div>
                                        </div>
                                        <div className="flexspace-between">
                                            <div className="tit-label">Pick up Time</div>
                                            <div className="selected-label">{pickUpTime}</div>
                                        </div>
                                     </div>
                                </div>
                                <div className="item-info-checkout">
                                   <h4 className="sub-check">PRICING</h4>
                                    <div className="total-info">
                                        <div className="fl-left">
                                            Total
                                        </div>
                                        <div className="fl-right">
                                            R {totalCost.toFixed(2)}
                                        </div>
                                    </div>
                                
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default CheckOut